import Vue from 'vue';
import Vuex from 'vuex';
import events from './events';
import user from './user';
import shared from './shared';

import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({ user: state.user, events: state.events })
});

export const store = new Vuex.Store({
  modules: {
    events: events,
    user: user,
    shared: shared
  },
  plugins: [vuexLocal.plugin]
});



// WEBPACK FOOTER //
// ./src/store/index.js